import React, { useState } from 'react';
import PaymentHistory from './PaymentHistory';
import './Profile.css';

const Profile = ({ user }) => {
  const [activeTab, setActiveTab] = useState('gifts');

  if (!user) {
    return <div className="loading-message">Загрузка профиля...</div>;
  }

  const getInitials = (name) => {
    return name ? name.charAt(0).toUpperCase() : '?';
  };

  return (
    <div className="profile-container">
      <div className="profile-header">
        <div className="profile-avatar">
          {user.avatar ? (
            <img src={user.avatar} alt={user.name} />
          ) : (
            <span className="profile-initials">{getInitials(user.name)}</span>
          )}
        </div>
        <h2 className="profile-name">{user.name}</h2>
        <p className="profile-username">@{user.username}</p>
      </div>

      <div className="profile-tabs">
        <button 
          className={`profile-tab ${activeTab === 'gifts' ? 'active' : ''}`}
          onClick={() => setActiveTab('gifts')}
        >
          Подарки
        </button>
        <button 
          className={`profile-tab ${activeTab === 'payments' ? 'active' : ''}`}
          onClick={() => setActiveTab('payments')}
        >
          Платежи
        </button>
      </div>

      <div className="profile-content">
        {activeTab === 'gifts' && (
          <div className="profile-inventory">
            <h3 className="inventory-title">История подарков</h3>
            <div className="inventory-list">
              {/* This will be populated later */}
              <p className="inventory-empty-message">не найдено</p>
            </div>
          </div>
        )}

        {activeTab === 'payments' && (
          <PaymentHistory userId={user.id} />
        )}
      </div>
    </div>
  );
};

export default Profile; 